import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/signature'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'signature_settings',
          component: Index,
          meta: {
            permissions: [
              'administrator',
              'agent',
              'custom_role',
              'conversation_manage',
              'conversation_page_access',
            ],
          },
        },
      ],
    },
  ],
};
